<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="12" sm="6">
        <h1>PROJECTS(All)</h1>
      </v-col>

      <v-col class="d-flex" cols="12" sm="4">
      <v-text-field label="Search For Anything Across System"></v-text-field>
      </v-col>

      <v-col class="d-flex" cols="12" sm="2">
       <div class="my-8">
         <ProjectModal/>
       </div>
      </v-col> 
    </v-row>
    <hr/>    
    <v-row align="center">
      <v-col cols="12" sm="2">
        <h3>Filter By</h3>
      </v-col>  
      <v-col class="d-flex" cols="12" sm="2">
      <v-select
          :items="['No Payment','Advance paid','Second advance paid','Fully paid']"
          label="Payment Status"
          v-model="paymentstatus"
          clearable="true"
        ></v-select>
      </v-col>

      <v-col class="d-flex" cols="12" sm="2">
        <v-select
          :items="['Standby','Working','Awaiting Resources','Testing','Pending Approval','Done']"
          label="Working Status"
          v-model="workingstatus"
          clearable="true"
        ></v-select>
      </v-col>

      <v-col class="d-flex" cols="12" sm="2">
        <v-select
          :items="['Website','Application','Branding','Other']"
          label="Types of Work"
          v-model="category"
          clearable="true"
        ></v-select>
      </v-col>

      <v-col class="d-flex" cols="12" sm="2">
        <v-select
          :items="['Lead','Working Quotation','Quotation Sent','Project Approved','Closed']"
          label="Project Status"
          v-model="projectstatus"
          clearable="true"
        ></v-select>
      </v-col>

      <v-col class="d-flex" cols="12" sm="2">
        <v-text-field label="Filter By Name" v-model="name"></v-text-field>
      </v-col>
    </v-row>
    <hr/>
    <v-data-table
    :headers="headers"
    :items="filteredProjects"
    class="elevation-1"
  >
    <template v-slot:item.payment_status="{ item }">
      <v-chip class="ma-2" color="red" text-color="white"
        v-if="item.payment_status=='No Payment'" small>{{item.payment_status}}</v-chip>
      <v-chip class="ma-2" color="yellow" text-color="black"
        v-else-if="item.payment_status=='Advance paid'" small>{{item.payment_status}}</v-chip>
      <v-chip class="ma-2" color="green" text-color="white"
        v-else-if="item.payment_status=='Second advance paid'" small>{{item.payment_status}}</v-chip>
      <v-chip class="ma-2" color="blue" text-color="white"
        v-else-if="item.payment_status=='Fully paid'" small>{{item.payment_status}}</v-chip>
    </template>
    <template v-slot:item.work_status="{ item }">
      <v-chip class="ma-2" color="red" text-color="white"
        v-if="item.work_status=='Standby'" small>{{item.work_status}}</v-chip>
      <v-chip class="ma-2" color="yellow" text-color="black"
        v-else-if="item.work_status=='Awaiting Resources'" small>{{item.work_status}}</v-chip>
      <v-chip class="ma-2" color="green" text-color="white"
        v-else-if="item.work_status=='Working'" small>{{item.work_status}}</v-chip>
      <v-chip class="ma-2" color="green" text-color="white"
        v-else-if="item.work_status=='Testing'" small>{{item.work_status}}</v-chip>  
      <v-chip class="ma-2" color="red" text-color="white"
        v-if="item.work_status=='Pending Approval'" small>{{item.work_status}}</v-chip>
      <v-chip class="ma-2" color="blue" text-color="white"
        v-else-if="item.work_status=='Done'" small>{{item.work_status}}</v-chip>
    </template>
    <template v-slot:item.action="{ item }">
      <div class="w-80">
      <ShowProject :projectid="item.id" :project="item"/>
      <ProjectEditModal :projectid="item.id" class="mx-2"/>
      <TaskModal :tasks="item.tasks" :projectid="item.id" class="mx-2"/>
      </div>
    </template>
  </v-data-table>

  </v-container>
</template>
<style>
a {
  text-decoration: none;
}
.w-80{
  width:80px;
}
</style>
<script>
import { mapGetters } from 'vuex';
import ShowProject from './ShowProject.vue';
import ProjectModal from './ProjectModal.vue';
import ProjectEditModal from './ProjectEditModal.vue';
import TaskModal from './TaskModal.vue';
  export default {
    components: {
    ShowProject,
    ProjectModal,
    ProjectEditModal,
    TaskModal,
    },
    data () {
      return {
        headers: [
          {
            text: 'Project Name',
            align: 'start',
            sortable: false,
            value: 'title',
          },
          { text: 'Type', value: 'category' },
          { text: 'W Status', value: 'work_status' },
          { text: 'P Status', value: 'payment_status' },
          { text: 'P Ammount', value: 'paid_amount' },
          { text: 'Quoted Price', value: 'quoted_amount' },
          { text: 'Assigned To', value: 'assignto.name' },
          { text: 'Due Date', value: 'deadline_date' },
          { text: 'Action', value: 'action' },
        ],
        name: this.$route.query.filtername,
        projectstatus: '',
        category: '',
        paymentstatus: '',
        workingstatus: '',
        rules: [
          value => !!value || 'Required.',
        ],
      }
    },
    computed: {
      ...mapGetters(["allprojects"]),
      filteredProjects() {
        return this.allprojects.filter(project => { 
            if(this.projectstatus) { return this.projectstatus === project.project_status;}
            return true;
        })
        .filter(project => {
            if(this.category) { return this.category === project.category;}
            return true;
        })
        .filter(project => {
            if(this.paymentstatus) { return this.paymentstatus === project.payment_status;}
            return true;
        })
        .filter(project => {
            if(this.workingstatus) { return this.workingstatus === project.work_status;}
            return true;
        })
        .filter(project => {
            if(this.name) { 
            console.log(this.name);
            return project.title.toLowerCase().indexOf(this.name.toLowerCase()) > -1;
            //return project.title.includes(this.name);
            }
            return true;
        });
      }
    },
  }
</script>